<section class="applications-page">
  <div class="level applications-page__header">
    <div class="level-left">
      <h2 class="title is-4 applications-page__title">Applications</h2>
    </div>
    <div class="level-right applications-page__actions">
      <a class="button is-primary is-small" [routerLink]="['/application-details']">
        Create New Application
      </a>
    </div>
  </div>

  <div class="applications-page__search box">
    <div class="level" style="margin-bottom: 0;">
      <div class="level-left">
        <div class="field has-addons">
          <div class="control">
            <input
              class="input"
              type="text"
              placeholder="Search applications…"
              [(ngModel)]="searchTerms"
              (keyup.enter)="search()"
              [disabled]="loading || searching"
            />
          </div>
          <div class="control">
            <button
              type="button"
              class="button is-info"
              (click)="search()"
              [disabled]="loading || searching"
            >
              {{ searching ? 'Searching…' : 'Search' }}
            </button>
          </div>
          <div class="control" *ngIf="searchTerms || hasActiveSearch">
            <button
              type="button"
              class="button"
              (click)="clearSearch()"
              [disabled]="loading || searching"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="level-right">
        <p class="help" *ngIf="searchError" style="color:#b00020; margin: 0;">{{ searchError }}</p>
      </div>
    </div>
  </div>

  <p *ngIf="loading">Loading…</p>
  <p *ngIf="!loading && error">{{ error }}</p>

  <div *ngIf="!loading && !error" class="table-container">
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th style="width: 6rem;">ID</th>
          <th>Name</th>
          <th>Contact</th>
          <th>Email</th>
          <th style="width: 7rem;">Active</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let app of applications; trackBy: trackByIndex">
          <td>
            <ng-container *ngIf="getApplicationId(app) as id; else noId">
              <a [routerLink]="['/application-details', id]">{{ id }}</a>
            </ng-container>
            <ng-template #noId>—</ng-template>
          </td>
          <td>
            <ng-container *ngIf="getApplicationId(app) as id; else nameOnly">
              <a [routerLink]="['/application-details', id]">{{ getApplicationName(app) }}</a>
            </ng-container>
            <ng-template #nameOnly>{{ getApplicationName(app) }}</ng-template>
          </td>
          <td>{{ getApplicationContactName(app) || '—' }}</td>
          <td>{{ getApplicationContactEmail(app) || '—' }}</td>
          <td>
            <ng-container *ngIf="getApplicationIsActive(app) !== null; else unknownActive">
              {{ getApplicationIsActive(app) ? 'Yes' : 'No' }}
            </ng-container>
            <ng-template #unknownActive>—</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="!loading && !error && applications.length === 0">No applications found.</p>
</section>
